import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Pelicula } from '../models/pelicula';
@Injectable({
  providedIn: 'root'
})
export class PeliculaService {



  constructor(private http: HttpClient) { }

  private peliculas: Pelicula[];
  private peliculas$ = new Subject<Pelicula[]>();

  private pelicula: Pelicula;
  private pelicula$ = new Subject<Pelicula>();

  change(val) {
    this.peliculas = val;
    this.peliculas$.next(this.peliculas);
  }
  get$(): Observable<Pelicula[]> {
    return this.peliculas$.asObservable();
  }

  changeOne(val) {
    this.pelicula = val;
    this.pelicula$.next(this.pelicula);
  }
  getOne$(): Observable<Pelicula> {
    return this.pelicula$.asObservable();
  }

  getAll(): Observable<Pelicula[]> {
    return this.http.get(environment.apiUrl + 'pelicula')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Pelicula[]> {

    return this.http.post(environment.apiUrl + 'pelicula/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'pelicula/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'pelicula', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'pelicula';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'pelicula/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  //
  // getTipo() {
  //   return this.http.get(environment.apiUrl + 'pelicula/getTipo')
  //     .pipe(map((res: any) => {
  //       return res;
  //     }));
  // }
  // getSeccion() {
  //   return this.http.get(environment.apiUrl + 'pelicula/getSeccion')
  //     .pipe(map((res: any) => {
  //       return res;
  //     }));
  // }
  //
  // changeImagePrincipal(formData: FormData, id): Observable<object> {
  //   return this.http.post(environment.apiUrl + 'pelicula/changeImgPrincipal/' + id, formData)
  //     .pipe(
  //       map((res: any) => { return res.data; }),
  //       catchError(e => throwError(e))
  //     );
  // }
  //
  // changeImageExtra(formData: FormData, id): Observable<object> {
  //   return this.http.post(environment.apiUrl + 'pelicula/changeImgExtra/' + id, formData)
  //     .pipe(
  //       map((res: any) => { return res.data; }),
  //       catchError(e => throwError(e))
  //     );
  // }
  //
  // deleteImg(id) {
  //   return this.http.delete(environment.apiUrl + 'pelicula/deleteImg/' + id)
  //     .pipe(
  //       map((res: any) => { return res; }),
  //       catchError(e => throwError(e))
  //     );
  // }
}
